import { apiFetch } from './client';

export type CourseSectionKind = 'folder' | 'conference' | 'quiz' | 'survey';

export interface CourseRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  ref_number: string;
  title: string;
  description: string | null;
  price_cents: number;
  currency: string;
  max_enrollment: number | null;
  starts_at: string | null;
  ends_at: string | null;
  active: boolean;
  section_count: number;
  enrollment_count: number;
  created_at: string;
  updated_at: string;
}

export interface CourseSectionRow {
  id: string;
  course_id: string;
  sort_order: number;
  section_kind: CourseSectionKind;
  target_id: string;
  title: string | null;
  created_at: string;
}

export interface EnrollmentRow {
  id: string;
  course_id: string;
  caller_id: string;
  enrolled_at: string;
  completed_at: string | null;
  cancelled_at: string | null;
}

export interface CreateCourseBody {
  title: string;
  description?: string | null;
  price_cents?: number;
  currency?: string;
  max_enrollment?: number | null;
  starts_at?: string | null;
  ends_at?: string | null;
  customer_id?: string;
}

export interface PatchCourseBody {
  title?: string;
  description?: string | null;
  price_cents?: number;
  currency?: string;
  max_enrollment?: number | null;
  starts_at?: string | null;
  ends_at?: string | null;
  active?: boolean;
}

export const courses = {
  list: (p: { search?: string; limit?: number; active?: boolean; customer_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.search) q.set('search', p.search);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.active) q.set('active', 'true');
    if (p.customer_id) q.set('customer_id', p.customer_id);
    return apiFetch<{ rows: CourseRow[] }>(`/api/courses?${q}`);
  },
  get: (id: string) => apiFetch<CourseRow>(`/api/courses/${id}`),
  create: (body: CreateCourseBody) =>
    apiFetch<CourseRow>('/api/courses', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: string, body: PatchCourseBody) =>
    apiFetch<CourseRow>(`/api/courses/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  remove: (id: string) =>
    apiFetch<void>(`/api/courses/${id}`, { method: 'DELETE' }),

  listSections: (courseId: string) =>
    apiFetch<{ rows: CourseSectionRow[] }>(`/api/courses/${courseId}/sections`),
  createSection: (courseId: string, body: {
    section_kind: CourseSectionKind;
    target_id: string;
    title?: string | null;
    sort_order?: number;
  }) =>
    apiFetch<CourseSectionRow>(`/api/courses/${courseId}/sections`, {
      method: 'POST', body: JSON.stringify(body),
    }),
  removeSection: (id: string) =>
    apiFetch<void>(`/api/course-sections/${id}`, { method: 'DELETE' }),

  listEnrollments: (courseId: string, p: { limit?: number; active?: boolean } = {}) => {
    const q = new URLSearchParams();
    if (p.limit) q.set('limit', String(p.limit));
    if (p.active) q.set('active', 'true');
    return apiFetch<{ rows: EnrollmentRow[] }>(`/api/courses/${courseId}/enrollments?${q}`);
  },
  cancelEnrollment: (id: string) =>
    apiFetch<void>(`/api/enrollments/${id}/cancel`, { method: 'POST' }),
};
